import { useId } from "react";
import { Button, Group, Stack, Text } from "@mantine/core";

const DEFAULT_ACCEPT = "image/jpeg,image/jpg,image/png,application/pdf";

const DocumentFilePicker = ({
  label,
  value,
  onChange,
  error,
  accept = DEFAULT_ACCEPT,
  disabled,
  placeholder = "Choose file",
}) => {
  const id = useId().replace(/:/g, "");

  const handleChange = (event) => {
    const file = event.target.files?.[0];
    if (file) onChange?.(file);
    event.target.value = "";
  };

  return (
    <Stack gap={6}>
      {label ? (
        <Text component="label" size="sm" fw={500}>
          {label}
        </Text>
      ) : null}
      <Text size="sm" c={value?.name ? undefined : "dimmed"} lineClamp={1}>
        {value?.name || placeholder}
      </Text>
      <Group gap="xs" wrap="wrap">
        <Button
          component="label"
          htmlFor={`${id}-camera`}
          size="compact-sm"
          variant="light"
          disabled={disabled}
        >
          Open camera
        </Button>
        <Button
          component="label"
          htmlFor={`${id}-gallery`}
          size="compact-sm"
          variant="light"
          disabled={disabled}
        >
          Choose from gallery
        </Button>
      </Group>
      <input
        id={`${id}-camera`}
        type="file"
        accept="image/*"
        capture="environment"
        hidden
        disabled={disabled}
        onChange={handleChange}
      />
      <input
        id={`${id}-gallery`}
        type="file"
        accept={accept}
        hidden
        disabled={disabled}
        onChange={handleChange}
      />
      {error ? (
        <Text size="xs" c="red">
          {error}
        </Text>
      ) : null}
    </Stack>
  );
};

export default DocumentFilePicker;
